import { FunctionComponent } from 'react';
import Image from 'next/image';
import styles from '../../../styles/ArticleFooter.module.scss';
import { AuthorModel } from '../../../services/content/author/models/AuthorModel';
import Link from 'next/link';
import { Routes } from '../../../constants/Routes';

type Props = {
    author?: AuthorModel;
    customAuthor?: string;
    className?: string;
};

export const Author: FunctionComponent<Props> = ({ author, customAuthor, className }) => {
    if (customAuthor) {
        return (
            <div className={className}>
                <Image
                    className={`${styles.authorAvatar} normalize-nextjs-image me-2`}
                    src='/user-placeholder.png'
                    alt={customAuthor}
                    fill
                />
                <span>{customAuthor}</span>
            </div>
        );
    }

    return (
        <div className={className}>
            <Link href={Routes.openAuthor(author?.id)}>
                <Image
                    className={`${styles.authorAvatar} normalize-nextjs-image me-2`}
                    src={author?.avatarUrl ? author.avatarUrl : '/user-placeholder.png'}
                    alt={author ? author.name : ''}
                    fill
                />
                <span>{author?.name}</span>
            </Link>
        </div>
    );
};
